<template>
  <div
    @click="routeToNews"
    :class="[index === 0 ? 'ml-8 ' : '', 'flex flex-col home-container mr-4']"
  >
    <div
      class="product-feature-image w-full overflow-hidden rounded-12 mb-4 container-shadow pointer-events-none"
    >
      <ion-img :src="feature.image" class="w-full h-full object-cover" />
    </div>
    <span class="font-helvetica-medium text-black text-16">{{
      feature.title
    }}</span>
  </div>
</template>

<script setup>
import { IonImg } from "@ionic/vue";
import { useRouter } from "vue-router";
import { defineProps } from "vue";

const props = defineProps({
  feature: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

const router = useRouter();

function routeToNews() {
  if (props.feature.link && props.feature.link.path) {
    router.push({
      path: props.feature.link.path,
      hash: props.feature.link.anchor ? "#" + props.feature.link.anchor : "",
    });
  }
}
</script>
<style scoped>
.product-feature-image {
  height: 170px;
  min-height: 170px;
}
.home-container {
  width: 240px;
  min-width: 240px;
}
</style>
